import React from 'react';

const ToggleIcon = ({ status }) => {
  const translateX = status ? 22.2861 : 0;

  return (
    <svg
      className="transition-all duration-300"
      width="48"
      height="30"
      viewBox="0 0 48 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="48"
        height="29.0391"
        rx="14.5196"
        className={status ? 'fill-[#61B8E7]' : 'fill-gray-300'}
      />
      <ellipse
        cx="12.857"
        cy="14.5197"
        rx="12"
        ry="13.257"
        fill="white"
        className="transition-transform duration-300"
        transform={`translate(${translateX}, 0)`}
      />
    </svg>
  );
};

export default ToggleIcon;
